import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'UploadExcel',
  //   description: 'description of UploadExcel',
  //   url: '/upload-excel',
  // },
];

export default help;
